import { Component, OnInit,Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MainService } from 'src/app/services/main.service';

@Component({
    selector: 'app-thermostat-status',
    templateUrl: './thermostat-status.component.html',
    styleUrls: ['./thermostat-status.component.css'],
    standalone: false
})
export class ThermostatStatusComponent implements OnInit {

  @Input() thermostatFeatureStatus: any;
  @Input() spaceId: any;
  thermostatRealTime: any;
  telemetryRealTime: any;
  thermostatId: any;

  constructor(private mainService: MainService, private activatedRoute: ActivatedRoute) {

  }

  ngOnInit(): void {
    this.thermostatId = this.activatedRoute.snapshot.paramMap.get('id');


    // Features live updates (Thermostat status updates)
    this.mainService.updateRealTimeDataForThermostats$.subscribe((data) => {

      const lastThermostat = data && data.length > 0 ? data[data.length - 1] : null;

      if (lastThermostat) {

        if(this.thermostatId === lastThermostat.thermostatId) {
          this.thermostatRealTime = lastThermostat;

          if(this.thermostatRealTime.thermostatMode) {
            this.thermostatFeatureStatus.mode = this.thermostatRealTime.thermostatMode;
            this.thermostatFeatureStatus.heatSetPoint = this.scaledCelsiusToFahrenheit(this.thermostatRealTime.setpoints.heatSetpoint);
            this.thermostatFeatureStatus.chillSetPoint = this.scaledCelsiusToFahrenheit(this.thermostatRealTime.setpoints.chillSetpoint);
            
            if(this.thermostatFeatureStatus.mode === 'auto') {
              const autoSetPoint = this.scaledCelsiusToFahrenheit(this.thermostatRealTime.setpoints.autoChillSetpoint) + "° - " +  this.scaledCelsiusToFahrenheit(this.thermostatRealTime.setpoints.autoHeatSetpoint) + "°";
              this.thermostatFeatureStatus.autoSetPoint = autoSetPoint;
            }
            else{
              this.thermostatFeatureStatus.autoSetPoint = '';
            }
          }

        }
      }
    });

    // Telemetry live updates (current temperature updates)
    this.mainService.telemetryDataForConnectedSystems$.subscribe((data) => {

      if (data && data.category == 'watertempSensor') {

        if(this.spaceId === data.spaceId) {
          this.telemetryRealTime = data;

          if(this.telemetryRealTime) {
            this.thermostatFeatureStatus.currentWaterTemp = this.scaledCelsiusToFahrenheit(this.telemetryRealTime.value);
          }

        }
      }
    });


  }

  scaledCelsiusToFahrenheit(scaledCelsius: number): number {
    const celsius = scaledCelsius / 10;              // 267 → 26.7
    const fahrenheit = (celsius * 9 / 5) + 32;  // → 80.06
    return Math.round(fahrenheit); 
  }

}